"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentConfig = void 0;
var config = {
    environment: 'development',
    baseUrl: 'https://events.gsudevelopment.com',
};
exports.developmentConfig = Object.freeze(config);
//# sourceMappingURL=development.js.map